import { Reveal } from "@/components/site/Reveal";
import { EXPERTISE } from "@/data/content";

export const Engagements = () => {
  return (
    <section id="uzmanlik" className="relative bg-surface py-28 md:py-40 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div>
            <Reveal>
              <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-8">Uzmanlık Alanları</p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-sand max-w-2xl">
                Uzmanlık alanlarım.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2}>
            <p className="text-sm font-light text-mist max-w-xs">
              Saha denetiminden mevzuata, deprem analizinden dijital dönüşüme.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {EXPERTISE.map((e, i) => (
            <Reveal key={e.tag} delay={i}>
              <div
                data-testid={`engagement-${i}`}
                className="group relative overflow-hidden rounded-sm h-[340px] md:h-[400px]"
              >
                <img
                  src={e.image}
                  alt={e.tag}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover grayscale brightness-[0.5] transition-all duration-[1200ms] ease-out group-hover:grayscale-0 group-hover:brightness-90 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
                <div className="absolute inset-0 ring-1 ring-inset ring-hairline" />
                <div className="absolute bottom-0 left-0 p-7 md:p-9">
                  <span className="text-[10px] tracking-[0.25em] uppercase text-gold">0{i + 1}</span>
                  <h3 className="mt-3 font-semibold tracking-tight text-2xl md:text-3xl text-sand max-w-md leading-tight">
                    {e.tag}
                  </h3>
                  <p className="mt-3 text-sm font-light text-sand/70 max-w-md">{e.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
